import React, {lazy, Suspense, useCallback, useEffect, useRef, useState} from "react";
import CategoryDialog from "../dialogs/CategoryDialog";
import AdSavedSuccessDialog from "../dialogs/AdSavedSuccessDialog";
import LoaderComponent from "../loaders/LoaderComponent";
// Removed unused imports
import RequestSvc from "../../services/RequestSvc";
import "./search.css";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import {fetchCategories} from "../../api/api";
import {NAME_HEADER_AUTH} from "../../utils/Constants";
import getStoredValue from "../../services/UseLocalStorage";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import ShowContentForUser from "../modalwindow/ShowContentForUser";
import {DownloadImgFromUrl} from '../../services/DownloadSvc';
import { saveAdToDashboard } from '../../services/AdSaveSvc';
import { normalizeCreativeUrl } from "../../utils/Utils";

const CardAdLazyComponent = lazy(() => import("../cardViews/CardViewAd"));
// Componente Card memorizado
const MemoizedCardAd = React.memo((
    {item, index, launchCategoryDialog, gridShowAdDetail, numberDuplicates, launchAdIADetailsDialog, saveProgress, featureUsage, isFeatureUsageLoading}) => (
    <Suspense fallback={<LoaderComponent/>}>
        <CardAdLazyComponent
            key={item.LibraryID}
            index={index}
            item={item}
            launchCategoryDialog={launchCategoryDialog}
            gridShowAdDetail={gridShowAdDetail}
            numberDuplicates={numberDuplicates}
            launchAdIADetailsDialog={launchAdIADetailsDialog}
            saveProgress={saveProgress}
            featureUsage={featureUsage}
            isFeatureUsageLoading={isFeatureUsageLoading}
        />
    </Suspense>
));

function AdResultGrid({
                          queryString,
                          setShowDetails,
                          showDetails,
                          setItemSelectedDetail,
                          setSidebarOpen,
                          setShowContainerNoMoreData,
                          numberDuplicates,
                          setNewRow,
                          setRefreshVaultTrigger
                      }) {
    
    const [totalPages, setTotalPages] = useState(null); // total pages from API
    const [currentPage, setCurrentPage] = useState(0); // last loaded page
    
    const [categories, setCategories] = useState([]);
    /**
     * Contiene los datos de la grilla, indexados por el collectionID o por el LibraryID
     */
    //const [rowsIndex] = useState([]);
    /**
     * Contiene los datos de la grilla.
     */
    const [rowsAdsData, setRowsAdsData] = useState([]);
    /**
     * Indica si hay mas paginas o anuncios por cargar.
     */
    const [hasMore, setHasMore] = useState(true);
    /**
     * Indica la pagina siguiente que se va a solicitar en el request.
     */
    // removed 'after' pagination
    const [currentURL, setCurrentURL] = useState("mainAPI");
    /**
     *
     * @type {React.MutableRefObject<null>}
     */
    const elementRef = useRef(null);
    /**
     * Contiene la informacion del card seleccionado.
     */
    const [itemSelected, setItemSelected] = useState({});
    /**
     *  Flag que indica si se muestra, o si esta oculto el dialogo de asignar categoria.
     */
    const [showCategoryDialog, setShowCategoryDialog] = useState(false);
    /**
     *  Contiene el codigo de la categoria selccionado por el usuario.
     */
    const [categorySelected, setCategorySelected] = useState(false);
    /**
     * Contiene el objecto del anuncio que se va a guardar.
     */
    const [ad, setAd] = useState({});

    // Success popup after save
    const [showAdSavedDialog, setShowAdSavedDialog] = useState(false);

    // Per-card save progress (concurrent saves supported)
    const [saveProgressByLibraryId, setSaveProgressByLibraryId] = useState({});
    const saveIntervalsRef = useRef(new Map()); // LibraryID -> intervalId
    const saveTimeoutsRef = useRef(new Map()); // LibraryID -> Set(timeoutId)
    /**
     * Flag para evitar requests concurrentes de páginas.
     */
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const [featureUsage, setFeatureUsage] = useState(null);
    const [isFeatureUsageLoading, setIsFeatureUsageLoading] = useState(false);

    // IA modal state
    const [showIADialog, setShowIADialog] = useState(false);
    const [iaItem, setIaItem] = useState(null);
    const [iaAnalysisData, setIaAnalysisData] = useState(null);
    const [textAnalysisData, setTextAnalysisData] = useState(null);
    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [isTextAnalyzing, setIsTextAnalyzing] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [openAccordion, setOpenAccordion] = useState('text'); // Default open accordion

    /**
     * Crear headers de forma configurable.
     * Evitamos agregar Content-Type para peticiones GET sin cuerpo porque fuerza preflight innecesario.
     * @param {Object} opts
     * @param {boolean} opts.includeAuth
     * @param {string|null} opts.contentType
     * @returns {Headers}
     */
    const createHeaders = useCallback(({ includeAuth = true, contentType = null } = {}) => {
        const h = new Headers();
        if (contentType) {
            h.append("Content-Type", contentType);
        }
        if (includeAuth) {
            const auth = getStoredValue(NAME_HEADER_AUTH);
            if (auth) h.append("Authorization", `Bearer ${auth}`);
        }
        return h;
    }, []);

    /*  END VARS    */


    /*  INIT EVENTS */

    /**
     * Mostrar el dialogo para seleccionar la categoria.
     * @param item
     */
    const launchCategoryDialog = useCallback((item) => {
        setShowCategoryDialog(true)
        setAd(item)
    }, [])

    const getAnalysisFromDB = useCallback(async (libraryId) => {
        if (!libraryId) return null;
        const url = `https://pulpoia-ops.com/backend/ads/analisis-ads?libraryId=${encodeURIComponent(libraryId)}`;
        try {
            const headers = createHeaders({ includeAuth: true });
            const res = await fetch(url, { method: 'GET', headers });
            if (res.status === 200) {
                return await res.json();
            }
            if (res.status === 404) {
                let json = null;
                try {
                    json = await res.json();
                } catch (e) {
                    // ignore
                }
                if (json?.message === 'Not found.') return null;
                return null;
            }
            console.error('[AdResultGrid] Unexpected status on cached analysis GET', res.status);
            return null;
        } catch (e) {
            console.error('[AdResultGrid] Error fetching cached analysis', e);
            return null;
        }
    }, [createHeaders]);

    const saveAnalysisToDB = useCallback(async (payload) => {
        if (!payload?.FK_LibraryID) return;
        const url = 'https://pulpoia-ops.com/backend/ads/analisis-ads';
        try {
            const headers = createHeaders({ includeAuth: true, contentType: 'application/json' });
            const res = await fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload),
            });
            if (!res.ok) {
                let json = null;
                try {
                    json = await res.json();
                } catch (e) {
                    // ignore
                }
                console.error('[AdResultGrid] Failed saving analysis to DB', res.status, json);
            }
        } catch (e) {
            console.error('[AdResultGrid] Error saving analysis to DB', e);
        }
    }, [createHeaders]);

    const extractTextAnalysisFromDB = useCallback((dbJson) => {
        if (!dbJson || typeof dbJson !== 'object') return null;
        const out = {};
        const pairs = [
            ['Analisis de antiguedad', dbJson['Analisis de antiguedad'] ?? dbJson['Analisis de antigüedad'] ?? dbJson['Analisis de antiguedad']],
            ['Contenido persuasivo', dbJson['Contenido persuasivo'] ?? dbJson['Contenido Persuasivo']],
            ['Problema/Deseo que Aborda', dbJson['Problema/Deseo que Aborda'] ?? dbJson['Problema'] ?? dbJson['Problema/Deseo']],
            ['Público Objetivo', dbJson['Público Objetivo'] ?? dbJson['Publico'] ?? dbJson['Público']],
        ];
        pairs.forEach(([k, v]) => {
            if (v != null && v !== '') out[k] = v;
        });
        return Object.keys(out).length ? out : null;
    }, []);

    const normalizeArray = useCallback((value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === 'string' && value.trim()) return [value.trim()];
        return [];
    }, []);

    const buildAnalysisPayloadForDB = useCallback(({ libraryId, iaData, textData }) => {
        const antiguedad =
            textData?.['Analisis de antiguedad'] ??
            textData?.['Analisis de antigüedad'] ??
            textData?.Antiguedad ??
            '';
        const contenidoPersuasivo =
            textData?.['Contenido persuasivo'] ??
            textData?.Contenido_Persuasivo ??
            textData?.ContenidoPersuasivo ??
            '';
        const problema =
            textData?.['Problema/Deseo que Aborda'] ??
            textData?.Problema ??
            textData?.Problema_Deseo ??
            '';

        const publico =
            iaData?.['Público Objetivo'] ??
            textData?.['Público Objetivo'] ??
            textData?.Publico ??
            '';
        const nicho = iaData?.['Nicho de Mercado'] ?? iaData?.Nicho ?? '';
        const paises = normalizeArray(iaData?.['País Potencial'] ?? iaData?.Paises);
        const idioma = iaData?.Idioma ?? '';
        const anguloCopy =
            iaData?.['Ángulo del Copy'] ??
            iaData?.['Ángulo del Copy (Persuasión)'] ??
            iaData?.Angulo_Copy ??
            '';
        const transcripcion = iaData?.['Transcripción'] ?? iaData?.Contenido_Video ?? '';
        const ganchoVideo = iaData?.Gancho_Video ?? '';

        return {
            FK_LibraryID: String(libraryId),
            Antiguedad: antiguedad,
            Contenido_Persuasivo: contenidoPersuasivo,
            Problema: problema,
            Publico: publico,
            Nicho: nicho,
            Paises: paises,
            Idioma: idioma,
            Angulo_Copy: anguloCopy,
            Gancho_Video: ganchoVideo,
            Contenido_Video: transcripcion,
        };
    }, [normalizeArray]);

    const closeIADialog = useCallback(() => {
        setShowIADialog(false);
        setIaItem(null);
        setIaAnalysisData(null);
        setTextAnalysisData(null);
    }, [])
    /**
     * Metodo para cerrar el dialogo de categorias.
     */
    const closeCategoryDialog = useCallback(() => {
        setShowCategoryDialog(false)
    }, [])

    const closeAdSavedDialog = useCallback(() => {
        setShowAdSavedDialog(false)
    }, [])
    /**
     * Metodo que se ejecuta cuando se selecciona una categoria
     * @param categorySelected
     */
    const onSelectCategory = useCallback((categorySelected) => {
        setCategorySelected(categorySelected)
    }, [])
    /**
     * Hacer el submit para guardar el anuncio.
     */
    const submitSaveAd = () => {
        setShowCategoryDialog(false)
        const adToSave = { ...ad, FK_Category_Code: categorySelected };
        saveAd(adToSave)
    }

    /**
     * (ECA) Función para mostrar la tarjeta de Detalles
     */
    const handleShowDetails = useCallback(async (item) => {
        setSidebarOpen(false)
        setShowDetails(true);
        setItemSelected(item);
        setItemSelectedDetail(item)
    }, [setItemSelectedDetail, setSidebarOpen, setShowDetails]);

    /**
     * (ECA) Función para cerrar la tarjeta de detalles
     */
    const handleCloseDetails = useCallback(() => {
        setShowDetails(false);
    }, [setShowDetails]);

    /**
     * (ECA)
     */
    const handleCardClick = useCallback((item) => {
        if (showDetails && itemSelected.LibraryID === item.LibraryID) {
            handleCloseDetails(); // (ECA) Si la misma tarjeta se clickea, cerrar
        } else {
            handleShowDetails(item); // (ECA) Muestra la tarjeta de detalles
        }
    }, [handleCloseDetails, handleShowDetails, itemSelected.LibraryID, showDetails]);
    /*  END EVENTS */


    /*  INIT METHODS    */

    /**
     * Descargar el creativo
     * @param fileType
     * @param src
     * @return {Promise<void>}
     */
    const onclickDownloadCreative = async (fileType, src) => {
        setIsDownloading(true);
        try {
            await DownloadImgFromUrl(src, fileType);
        } catch (error) {
            console.error("Download failed:", error);
            // Optionally show an error message to the user
        } finally {
            setIsDownloading(false);
        }
    };

    const TimeTimestampToUnix = useCallback(() => {
        const currentTimeMillis = Date.now();
        const unixTime = Math.floor(currentTimeMillis / 1000);
        return unixTime;
    }, []);

    const fetchTextAnalysis = useCallback(async (item) => {
        //setIsTextAnalyzing(true); // State is set in launchAdIADetailsDialog
        try {
            const payload = {
                "__html": item.AdText,
                "Active": item.Active,
                "startDate": item.startDate,
                "currentDate": TimeTimestampToUnix(),
                "endDate": item.endDate,
                "LibraryID": item.LibraryID,
                "ahref": item.ahref,
                "AdTitle": item.AdTitle,
                "codeBelongs": item.codeBelongs,
                "keywords": queryString ? new URLSearchParams(queryString).get('keywords') : ''
            };

            const response = await fetch('https://juan1ondonolinks.com/adAnalyzer/jsonAdAnalyzer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setTextAnalysisData(data);
            return data;
        } catch (error) {
            console.error("Error fetching text analysis:", error);
            setTextAnalysisData(null);
            return null;
        } finally {
            setIsTextAnalyzing(false);
        }
    }, [TimeTimestampToUnix, queryString]);

    const fetchAdAnalysis = useCallback(async (item) => {
        //setIsAnalyzing(true); // State is set in launchAdIADetailsDialog
        try {
            const response = await fetch('https://juan1ondonolinks.com/adAnalyzer/analyzeAd', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(item),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setIaAnalysisData(data);
            return data;
        } catch (error) {
            console.error("Error fetching ad analysis:", error);
            // Optionally, set an error state to show in the UI
            setIaAnalysisData(null);
            return null;
        } finally {
            setIsAnalyzing(false);
        }
    }, []);

    // Launch IA details dialog (DB-first to avoid expensive Gemini calls when cached)
    const launchAdIADetailsDialog = useCallback(async (item) => {
        setIaItem(item);
        setShowIADialog(true);
        setIaAnalysisData(null);
        setTextAnalysisData(null);
        setLoadingMessage('');
        setIsAnalyzing(true);
        setIsTextAnalyzing(true);
        setOpenAccordion('text');

        const libraryId = item?.LibraryID;
        if (!libraryId) {
            console.warn('[AdResultGrid] launchAdIADetailsDialog: Missing item.LibraryID');
            setIsAnalyzing(false);
            setIsTextAnalyzing(false);
            return;
        }

        try {
            const cached = await getAnalysisFromDB(libraryId);
            if (cached) {
                // Use cached data and skip costly analysis endpoints
                setIaAnalysisData(cached);
                setTextAnalysisData(extractTextAnalysisFromDB(cached));
                setIsAnalyzing(false);
                setIsTextAnalyzing(false);
                return;
            }

            // Not cached: run analysis (costly) and then persist
            const [iaData, textData] = await Promise.all([
                fetchAdAnalysis(item),
                fetchTextAnalysis(item),
            ]);

            const payload = buildAnalysisPayloadForDB({ libraryId, iaData, textData });
            await saveAnalysisToDB(payload);
        } catch (e) {
            console.error('[AdResultGrid] Error in launchAdIADetailsDialog flow', e);
            // Ensure spinners stop if anything unexpected happens
            setIsAnalyzing(false);
            setIsTextAnalyzing(false);
        }
    }, [buildAnalysisPayloadForDB, extractTextAnalysisFromDB, fetchAdAnalysis, fetchTextAnalysis, getAnalysisFromDB, saveAnalysisToDB]);

    const trackSaveTimeout = useCallback((libraryId, timeoutId) => {
        const existing = saveTimeoutsRef.current.get(libraryId) ?? new Set();
        existing.add(timeoutId);
        saveTimeoutsRef.current.set(libraryId, existing);
    }, []);

    const clearSaveTimers = useCallback((libraryId) => {
        const intervalId = saveIntervalsRef.current.get(libraryId);
        if (intervalId) {
            clearInterval(intervalId);
            saveIntervalsRef.current.delete(libraryId);
        }
        const timeouts = saveTimeoutsRef.current.get(libraryId);
        if (timeouts) {
            timeouts.forEach(t => clearTimeout(t));
            saveTimeoutsRef.current.delete(libraryId);
        }
    }, []);

    const startSaveProgress = useCallback((libraryId) => {
        if (!libraryId) return;
        setSaveProgressByLibraryId(prev => {
            if (prev[libraryId] != null) return prev;
            return { ...prev, [libraryId]: 6 };
        });
        if (saveIntervalsRef.current.has(libraryId)) return;

        const intervalId = setInterval(() => {
            setSaveProgressByLibraryId(prev => {
                const current = prev[libraryId];
                if (current == null) return prev;
                // Ease-out towards 90 while the request is in-flight
                const cap = 90;
                if (current >= cap) return prev;
                const delta = Math.max(1, Math.round((cap - current) / 12));
                const next = Math.min(cap, current + delta);
                if (next === current) return prev;
                return { ...prev, [libraryId]: next };
            });
        }, 120);

        saveIntervalsRef.current.set(libraryId, intervalId);
    }, []);

    const finishSaveProgress = useCallback((libraryId, { showDialog = true } = {}) => {
        if (!libraryId) return;
        clearSaveTimers(libraryId);
        setSaveProgressByLibraryId(prev => ({ ...prev, [libraryId]: 100 }));

        const t1 = setTimeout(() => {
            if (showDialog) setShowAdSavedDialog(true);
            const t2 = setTimeout(() => {
                setSaveProgressByLibraryId(prev => {
                    if (prev[libraryId] == null) return prev;
                    const next = { ...prev };
                    delete next[libraryId];
                    return next;
                });
                clearSaveTimers(libraryId);
            }, 650);
            trackSaveTimeout(libraryId, t2);
        }, 300);

        trackSaveTimeout(libraryId, t1);
    }, [clearSaveTimers, trackSaveTimeout]);

    const failSaveProgress = useCallback((libraryId) => {
        if (!libraryId) return;
        clearSaveTimers(libraryId);
        setSaveProgressByLibraryId(prev => {
            if (prev[libraryId] == null) return prev;
            const next = { ...prev };
            delete next[libraryId];
            return next;
        });
    }, [clearSaveTimers]);

    // Build sanitized base query removing pagination and disabled filter params
    const buildBaseQuery = () => {
        const params = new URLSearchParams(queryString || '');
        params.delete('page');
        params.delete('limit');
        // Remove disabled filter combos (CTA, status, countries, platforms)
        params.delete('cta');
        params.delete('ad_active_status');
        params.delete('ad_reached_countries');
        params.delete('publisher_platforms');
        return params.toString();
    };

    // When backend filters out inactive ads, some pages can come back empty.
    // We keep advancing pages until we find data or pagination says we're done.
    // This avoids relying on IntersectionObserver firing again (which may not happen
    // if the sentinel stays intersecting).
    const MAX_PAGE_SCANS_WITHOUT_DATA_FALLBACK = 2000;

    const loadAds = async () => {
        if (isLoading || !hasMore) return; // Evitar llamadas múltiples

        setIsLoading(true);
        try {
            const limit = 5; // Ajustar si se requiere
            const baseQuery = buildBaseQuery();
            const params = new URLSearchParams(baseQuery);
            // Check if keywords parameter exists and has a non-empty value
            // This determines which API endpoint to use for the search
            const hasKeywords = params.has('keywords') && (params.get('keywords') || '').trim() !== '';

            // NOTE: Backend sends a 301 redirect from /search to /search/ (trailing slash).
            // Redirect on CORS preflight (OPTIONS) causes browser failure, so we use the
            // canonical URL with trailing slash directly when keywords are present.
            /*const endpoint = hasKeywords
                ? 'https://pulpoia-ops.com/backend/search/'
                : 'https://pulpoia-ops.com/backend/ads/getads';*/

            const endpoint = 'https://pulpoia-ops.com/backend/ads/getads';
            //const endpoint = 'http://localhost:3001/getads';

            const headersToRequest = createHeaders({ includeAuth: true });

            let pageToFetch = currentPage + 1;
            const startingPage = currentPage;
            let localTotalPages = totalPages;
            let requestsMade = 0;

            const getNextPageToFetch = (jsonAfter, current) => {
                const afterNum = Number(jsonAfter);
                if (Number.isFinite(afterNum) && afterNum > current) return afterNum;
                return current + 1;
            };

            while (true) {
                // Upper bound: don't let a single load call loop forever.
                const maxRequestsThisCall = localTotalPages !== null
                    ? Math.max(0, localTotalPages - startingPage)
                    : MAX_PAGE_SCANS_WITHOUT_DATA_FALLBACK;
                if (requestsMade >= maxRequestsThisCall) {
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return;
                }

                if (localTotalPages !== null && pageToFetch > localTotalPages) {
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return;
                }

                const queryWithPagination = `${baseQuery}${baseQuery ? '&' : ''}limit=${limit}&page=${pageToFetch}`;
                const url = `${endpoint}?${queryWithPagination}`;
                console.log(`[AdResultGrid] Fetch page ${pageToFetch} from ${endpoint} (hasKeywords=${hasKeywords}) -> ${url}`);

                const res = await fetch(url, { method: 'GET', headers: headersToRequest });
                requestsMade += 1;
                if (res.status !== 200) {
                    console.error('Status != 200', res.status);
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return;
                }

                const json = await res.json();
                if (json.error || json.code !== 200) {
                    console.warn('Logical error response', json.message);
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return;
                }

                const serverTotalPages = json?.info?.totalPages;
                const serverHasNextPage = json?.info?.hasNextPage;

                if (localTotalPages === null && serverTotalPages) {
                    localTotalPages = serverTotalPages;
                    setTotalPages(serverTotalPages);
                }

                const ads = json?.data || [];

                const hasNextPage = typeof serverHasNextPage === 'boolean'
                    ? serverHasNextPage
                    : (localTotalPages !== null ? pageToFetch < localTotalPages : true);

                // Key fix: if a page is empty but we are not at the last page yet,
                // advance and try again instead of stopping.
                if (ads.length === 0) {
                    if (hasNextPage) {
                        setCurrentPage(pageToFetch);
                        pageToFetch = getNextPageToFetch(json?.after, pageToFetch);
                        continue;
                    }

                    setCurrentPage(pageToFetch);
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                    return;
                }

                // Append + dedupe (LibraryID)
                setRowsAdsData(prev => {
                    const map = new Map();
                    [...prev, ...ads].forEach(ad => {
                        if (!map.has(ad.LibraryID)) map.set(ad.LibraryID, ad);
                    });
                    return Array.from(map.values());
                });

                setCurrentPage(pageToFetch);

                if (!hasNextPage || (localTotalPages !== null && pageToFetch >= localTotalPages)) {
                    setHasMore(false);
                    setShowContainerNoMoreData(true);
                }

                return;
            }
        } catch (e) {
            console.error('Error loading ads', e);
            setHasMore(false);
            setShowContainerNoMoreData(true);
        } finally {
            setIsLoading(false);
        }
    };

    /**
     * Cargar las categorias del usuario.
     * @return {Promise<void>}
     */
    const loadUserCategories = async () => {
        try {
            let results = await fetchCategories();
            setCategories(results)
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * Guardar el anuncio
     * @param adObject
     * @return {Promise<void>}
     */
    const saveAd = useCallback(async (adObject) => {
        const libraryId = adObject?.LibraryID;
        if (!libraryId) return;
        // Prevent duplicate concurrent save on same card
        if (saveProgressByLibraryId[libraryId] != null) return;

        startSaveProgress(libraryId);
        try {
            const savedAd = await saveAdToDashboard(adObject);
            if (!savedAd) {
                failSaveProgress(libraryId);
                return;
            }

            console.log("Ad saved successfully, notifying UserVaultGrid:", savedAd);
            setNewRow(savedAd);

            if (setRefreshVaultTrigger) {
                setRefreshVaultTrigger(prev => prev + 1);
            }

            finishSaveProgress(libraryId, { showDialog: true });
        } catch (e) {
            console.error('Error saving ad', e);
            failSaveProgress(libraryId);
        }
    }, [failSaveProgress, finishSaveProgress, saveProgressByLibraryId, setNewRow, setRefreshVaultTrigger, startSaveProgress]);

    /**
     * Callback para el IntersectionObserver que maneja la carga infinita
     * Se ejecuta cuando el elemento observado entra en el viewport
     * @param {IntersectionObserverEntry[]} entries - Array de elementos observados
     * @returns {Promise<void>}
     */
    const onIntersection = async (entries) => {
        const firstEntry = entries[0];
        if (firstEntry.isIntersecting && hasMore && queryString && !isLoading) {
            await loadAds();
        }
    }
    /**
     * Eliminar las filas que tienen el creativo no existente o invalido.
     * @param arrayAdsObjects
     * @return {Promise<*[]>}
     */
    /*const cleanResponseContent = async (arrayAdsObjects) => {
        let result = {}
        const processedItems = await Promise.all(
            arrayAdsObjects.flatMap(async (adObject) => {
                if (adObject.AdMedia === 'video') {
                    try {
                        let respuesta = await validateExistVideo(adObject.AdCreative)
                        return {
                            ...adObject,
                            existSrc: respuesta.isValid
                        }
                    } catch (error) {
                        return {
                            ...adObject,
                            existSrc: error.isValid
                        }
                    }
                } else {
                    try {
                        let respuesta = await validateExistImg(adObject.AdCreative)
                        return {
                            ...adObject,
                            existSrc: respuesta.isValid
                        }
                    } catch (error) {
                        return {
                            ...adObject,
                            existSrc: error.isValid
                        }
                    }
                }
            })
        )
        return deleteInvalidRows(processedItems);
    }*/

    /**
     * Eliminar del arreglo las filas que tienen la propiedad
     * existSrc=false
     * @param processedItems
     * @return {*[]}
     */
    /*function deleteInvalidRows(processedItems) {
        let cleanData = [];
        processedItems.forEach((item) => {
            if (item.existSrc === true) {
                cleanData.push(item)
            }
        })
        console.log("OJO CON cleanData", cleanData)
        return createDuplicates(cleanData);
    }*/

    /**
     * Crear los duplicados
     * @param cleanData
     * @return {*[]}
     * 9396831630345217
     */
    /*function createDuplicates(cleanData) {
        cleanData.forEach((element) => {
            let indexKey = element.CollationID ?? element.LibraryID;
            if (Object.prototype.hasOwnProperty.call(rowsIndex, indexKey)) {
                rowsIndex[indexKey].duplicated++;
            } else {
                element.duplicated = 1;
                rowsIndex[indexKey] = element;
            }
        })
        // console.log("rowsIndex", rowsIndex)
        let rows = []
        for (let indexKey in rowsIndex) {
            rows.push(rowsIndex[indexKey]);
        }
        console.log("LAS FILAS rows SON = >", rows)
        return rows;
    }*/

    /**
     * Validar si el creativo esta disponible para mostrar cuando es tipo imagen.
     * @param urlImg
     * @return {Promise<unknown>}
     */
   /* async function validateExistImg(urlImg) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve({isValid: true})
            img.onerror = () => reject({isValid: false});
            img.src = urlImg
        })
    }*/

    /**
     * Validar si el creativo esta disponible para mostrar cuando es tipo video.
     * @param urlVideo
     * @return {Promise<unknown>}
     */
    /*function validateExistVideo(urlVideo) {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video')
            video.onloadedmetadata = () => resolve({isValid: true})
            video.onerror = () => reject({isValid: false});
            video.src = urlVideo
        })
    }*/

    /*  END METHODS */
    
    useEffect(() => {
        if (queryString) {
            setRowsAdsData([]);
            setHasMore(true);
            setShowContainerNoMoreData(false);
            setTotalPages(null);
            setCurrentPage(0);
            setIsLoading(false);
            // Cancel any in-flight save indicators when the query changes
            saveIntervalsRef.current.forEach(intervalId => clearInterval(intervalId));
            saveIntervalsRef.current.clear();
            saveTimeoutsRef.current.forEach(setOfTimeouts => setOfTimeouts.forEach(t => clearTimeout(t)));
            saveTimeoutsRef.current.clear();
            setSaveProgressByLibraryId({});
            loadAds(); // initial fetch
        }
    }, [queryString]);

    useEffect(() => {
        return () => {
            // Cleanup all timers on unmount
            saveIntervalsRef.current.forEach(intervalId => clearInterval(intervalId));
            saveIntervalsRef.current.clear();
            saveTimeoutsRef.current.forEach(setOfTimeouts => setOfTimeouts.forEach(t => clearTimeout(t)));
            saveTimeoutsRef.current.clear();
        };
    }, []);

    useEffect(() => {
        if (showIADialog) {
            console.log("iaItem object:", iaItem);
        }
    }, [showIADialog, iaItem]);

    useEffect(() => {
        if (isAnalyzing) {
            const messages = [
                { text: "PulpoIA se sumerge en el archivo... Calibrando tentáculos para el análisis de alta complejidad.", delay: 0 },
                { text: "Escaneando ondas de sonido... ¡Idioma detectado! Portugués confirmado.", delay: 15000 },
                { text: "Mapeando el ecosistema de nichos... Profundizando...", delay: 30000 },
                { text: "Brazos de PulpoIA filtrando datos geográficos... Encontrando ecosistemas potenciales de mayor retorno: Brasil y Portugal.", delay: 50000 },
                { text: "PulpoIA tejiendo redes de datos socio-demográficos... Construyendo el perfil del cliente ideal...", delay: 75000 },
                { text: "Tentáculos de PulpoIA descifrando el ADN del mensaje... Revelando la estrategia de persuasión: Contraste Dramático.", delay: 105000 }
            ];

            const timeouts = messages.map(msg =>
                setTimeout(() => {
                    setLoadingMessage(msg.text);
                }, msg.delay)
            );

            // Cleanup function to clear timeouts if the component unmounts or analysis stops
            return () => {
                timeouts.forEach(clearTimeout);
            };
        }
    }, [isAnalyzing]);

    useEffect(() => {
        loadUserCategories()
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadFeatureUsage = async () => {
            setIsFeatureUsageLoading(true);
            try {
                const requestSvc = new RequestSvc();
                const response = await requestSvc.get("https://pulpoia-ops.com/backend/ads/user-features");
                if (!isMounted) return;
                if (response?.error) {
                    console.warn('[AdResultGrid] Feature usage response error', response?.message);
                    setFeatureUsage(null);
                    return;
                }
                setFeatureUsage(Array.isArray(response?.data) ? response.data : null);
            } catch (e) {
                if (!isMounted) return;
                console.warn('[AdResultGrid] Feature usage fetch failed', e);
                setFeatureUsage(null);
            } finally {
                if (isMounted) setIsFeatureUsageLoading(false);
            }
        };

        loadFeatureUsage();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        // Crear un nuevo IntersectionObserver con un margen amplio para precarga
        // y un umbral del 50% de visibilidad del elemento
        const observer = new IntersectionObserver(onIntersection, {rootMargin: '1250px', threshold: 0.5})
        if (observer && elementRef.current) observer.observe(elementRef.current)
        return () => {
            if (observer) observer.disconnect()
        }
    }, [rowsAdsData])


    return (
        <div className={"grid-main-layout"} style={{marginTop: "0", marginRight: "8px"}}>
            <ResponsiveMasonry
                columnsCountBreakPoints={
                    {
                        340: 1, 500: 2, 800: 3, 1200: 4, 1600: 5, 1800: 6, 2200: 7
                    }
                }
                style={{marginLeft: "8px", marginRight: "8px"}}
            >
                <Masonry gutter={"16px"}>
                    {
                        rowsAdsData.map((item, ) => {
                            // let display = item.duplicated >= numberDuplicates ? "grid" : "none";
                            let display = true; //item.duplicates >= numberDuplicates;
                            return display && (
                                <div key={item.LibraryID} style={{display: "grid"}}>
                                    <MemoizedCardAd
                                        item={item}
                                        launchCategoryDialog={launchCategoryDialog}
                                        gridShowAdDetail={handleCardClick}
                                        numberDuplicates={numberDuplicates}
                                        launchAdIADetailsDialog={launchAdIADetailsDialog}
                                        saveProgress={saveProgressByLibraryId[item.LibraryID]}
                                        featureUsage={featureUsage}
                                        isFeatureUsageLoading={isFeatureUsageLoading}
                                    />
                                </div>
                            )
                        })
                    }
                </Masonry>
            </ResponsiveMasonry>
            {
                showCategoryDialog && (
                    <CategoryDialog
                        rows={categories}
                        open={showCategoryDialog}
                        closeCategoryDialog={closeCategoryDialog}
                        onSelectCategory={onSelectCategory}
                        submitSaveAd={submitSaveAd}/>
                )
            }

            <AdSavedSuccessDialog
                open={showAdSavedDialog}
                onClose={closeAdSavedDialog}
            />
            {
                hasMore && (
                    <div className="grid-reference-limit-loading" ref={elementRef}>


                        <div style={{
                            marginTop: '20px',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(7, 1fr)',
                            gap: '10px'
                        }}>
                            {[...Array(7)].map((_, index) => (
                                <Skeleton
                                    key={index}
                                    style={{
                                        height: '300px',
                                        borderRadius: '8px',
                                    }}
                                />
                            ))}
                        </div>


                    </div>
                )
            }

            {/* IA Details Modal */}
            {showIADialog && (
                <ShowContentForUser
                    onClose={closeIADialog}
                    width={1100}
                    height={650}
                    myIframe={
                        <div style={{ background: '#0a0a0a', color: '#fff', width: '100%' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: 16, padding: 16, minHeight: 0 }}>
                                {/* Left column: creative */}
                                <div style={{ background: '#111', borderRadius: 8, padding: 8 }}>
                                    {iaItem?.AdMedia === 'video' ? (
                                        <video
                                            src={normalizeCreativeUrl(iaItem?.AdCreative)}
                                            poster={!iaItem?.url_preview_creative?.includes('fbcdn') ? iaItem?.url_preview_creative : undefined}
                                            controls
                                            style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'contain', borderRadius: 8 }}
                                        />
                                    ) : (
                                        <img
                                            src={normalizeCreativeUrl(iaItem?.AdCreative)}
                                            alt={iaItem?.LibraryID || 'ad'}
                                            style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'contain', borderRadius: 8 }}
                                        />
                                    )}

                                    <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                        <button
                                            onClick={() => launchCategoryDialog(iaItem)}
                                            style={{
                                            background: '#1f2937', color: '#d1d5db', border: '1px solid #374151',
                                            padding: '8px 12px', borderRadius: 8, cursor: 'pointer'
                                        }}>Guardar</button>
                                        <button
                                            onClick={() => onclickDownloadCreative(iaItem.AdMedia, normalizeCreativeUrl(iaItem?.AdCreative))}
                                            style={{
                                            background: '#10b981', color: '#0b0f0f', border: 'none',
                                            padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600
                                        }}>Descargar</button>
                                    </div>
                                    {isDownloading && (
                                        <div style={{ marginTop: '10px', width: '100%', background: '#1f2937', borderRadius: '4px', overflow: 'hidden' }}>
                                            <div style={{ width: '100%', height: '4px', background: 'linear-gradient(90deg, transparent, #10b981, transparent)', animation: 'progress-animation 1.5s infinite' }}></div>
                                            <style>{`
                                                @keyframes progress-animation {
                                                    0% { transform: translateX(-100%); }
                                                    100% { transform: translateX(100%); }
                                                }
                                            `}</style>
                                        </div>
                                    )}
                                </div>

                                {/* Right column: dynamic IA description */}
                                <div style={{ background: '#0f172a', borderRadius: 12, padding: 16, border: '1px solid #1f2937', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                        <span role="img" aria-label="spark">🎯</span>
                                        <div style={{ fontWeight: 700, fontSize: 16, color: '#ffffff' }}>Análisis con PulpoIA</div>
                                    </div>
                                    
                                    <div style={{ flexGrow: 1, overflow: 'auto' }}>
                                        {/* Accordion for Text Analysis */}
                                        <div style={{ border: '1px solid #1f2937', borderRadius: '8px', marginBottom: '16px' }}>
                                            <button
                                                onClick={() => setOpenAccordion(openAccordion === 'text' ? null : 'text')}
                                                style={{
                                                    background: '#0f172a',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '12px 16px',
                                                    width: '100%',
                                                    textAlign: 'left',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    borderTopLeftRadius: '8px',
                                                    borderTopRightRadius: '8px',
                                                    borderBottom: openAccordion === 'text' ? '1px solid #1f2937' : 'none'
                                                }}
                                            >
                                                <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>ANALISIS DEL TEXTO DEL ANUNCIO</h2>
                                                <span style={{ fontSize: '20px' }}>{openAccordion === 'text' ? '−' : '+'}</span>
                                            </button>
                                            {openAccordion === 'text' && (
                                                <div style={{ padding: '16px' }}>
                                                    {isTextAnalyzing ? (
                                                        <div>
                                                            {[...Array(3)].map((_, index) => (
                                                                <div key={index} style={{ marginBottom: '12px' }}>
                                                                    <Skeleton height={20} width={120} style={{ background: '#1f2937', borderRadius: '4px', marginBottom: '4px' }} />
                                                                    <Skeleton height={30} style={{ background: '#1f2937', borderRadius: '4px' }} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : textAnalysisData ? (
                                                        <div>
                                                            {Object.entries(textAnalysisData).map(([key, value]) => (
                                                                <div key={key} style={{ marginBottom: '12px' }}>
                                                                    <div style={{ color: '#d1d5db', fontWeight: 600, marginBottom: '4px' }}>{key}</div>
                                                                    <div style={{ color: '#e5e7eb' }}>{value}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div>No se pudo cargar el análisis del texto.</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Accordion for Creative Analysis */}
                                        <div style={{ border: '1px solid #1f2937', borderRadius: '8px', marginBottom: '16px' }}>
                                            <button
                                                onClick={() => setOpenAccordion(openAccordion === 'creative' ? null : 'creative')}
                                                style={{
                                                    background: '#0f172a',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '12px 16px',
                                                    width: '100%',
                                                    textAlign: 'left',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    borderTopLeftRadius: '8px',
                                                    borderTopRightRadius: '8px',
                                                    borderBottom: openAccordion === 'creative' ? '1px solid #1f2937' : 'none'
                                                }}
                                            >
                                                <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>ANALISIS DEL CREATIVO</h2>
                                                <span style={{ fontSize: '20px' }}>{openAccordion === 'creative' ? '−' : '+'}</span>
                                            </button>
                                            {openAccordion === 'creative' && (
                                                <div style={{ padding: '16px' }}>
                                                    {isAnalyzing ? (
                                                        <div>
                                                            <div style={{
                                                                display: 'grid', gridTemplateColumns: '220px 1fr',
                                                                gap: 12, color: '#e5e7eb'
                                                            }}>
                                                                {[...Array(5)].map((_, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <Skeleton height={20} width={150} style={{ background: '#1f2937', borderRadius: '4px' }} />
                                                                        <Skeleton height={40} style={{ background: '#1f2937', borderRadius: '4px' }} />
                                                                    </React.Fragment>
                                                                ))}
                                                            </div>
                                                            <div style={{ marginTop: '20px', color: '#ffffffff', textAlign: 'center', fontStyle: 'italic' }}>
                                                                {loadingMessage}
                                                            </div>
                                                        </div>
                                                    ) : iaAnalysisData ? (
                                                        <div style={{
                                                            display: 'grid', gridTemplateColumns: '220px 1fr',
                                                            gap: 12, color: '#e5e7eb'
                                                        }}>
                                                            <div style={{ color: '#9ca3af', fontWeight: 600 }}>Categoría</div>
                                                            <div style={{ color: '#9ca3af', fontWeight: 600 }}>Descripción</div>
                                                            <div style={{ color: '#d1d5db', fontWeight: 600 }}>Nicho de Mercado</div>
                                                            <div>{iaAnalysisData["Nicho de Mercado"]}</div>
                                                            <div style={{ color: '#d1d5db', fontWeight: 600 }}>Público Objetivo</div>
                                                            <div>{iaAnalysisData["Público Objetivo"]}</div>
                                                            <div style={{ color: '#d1d5db', fontWeight: 600 }}>País Potencial</div>
                                                            <div>{Array.isArray(iaAnalysisData["País Potencial"]) ? iaAnalysisData["País Potencial"].join(', ') : iaAnalysisData["País Potencial"]}</div>
                                                            <div style={{ color: '#d1d5db', fontWeight: 600 }}>Idioma</div>
                                                            <div>{iaAnalysisData["Idioma"]}</div>
                                                            <div style={{ color: '#d1d5db', fontWeight: 600 }}>Ángulo de Copy (Persuasión)</div>
                                                            <div>{iaAnalysisData["Ángulo del Copy"]}</div>
                                                        </div>
                                                    ) : (
                                                        <div>No se pudo cargar el análisis de la imagen.</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Accordion for Video Script */}
                                        {iaAnalysisData && iaAnalysisData["Transcripción"] && (
                                            <div style={{ border: '1px solid #1f2937', borderRadius: '8px' }}>
                                                <button
                                                    onClick={() => setOpenAccordion(openAccordion === 'script' ? null : 'script')}
                                                    style={{
                                                        background: '#0f172a',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        width: '100%',
                                                        textAlign: 'left',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        borderTopLeftRadius: '8px',
                                                        borderTopRightRadius: '8px',
                                                        borderBottom: openAccordion === 'script' ? '1px solid #1f2937' : 'none'
                                                    }}
                                                >
                                                    <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>GUIÓN DEL VIDEO</h2>
                                                    <span style={{ fontSize: '20px' }}>{openAccordion === 'script' ? '−' : '+'}</span>
                                                </button>
                                                {openAccordion === 'script' && (
                                                    <div style={{ padding: '16px' }}>
                                                        <div style={{ color: '#e5e7eb', whiteSpace: 'pre-wrap' }}>
                                                            {iaAnalysisData["Transcripción"]}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            )}
        </div>
    )
} // end main function

export default React.memo(AdResultGrid);